import React, { useCallback } from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useActions } from '@app/external/common/components/runtime-context';
import type { NormalizedPost } from '@app/external/common/types';
import ReadingTimeListener, {
  type OnScrollHandler,
  type OnTabVisibilityChangeHandler,
} from '../../components/reading-time-listener/use-reading-time-listener';

type Props = {
  post?: NormalizedPost;
  readingSessionId: string;
};

const PostPageReadingTimeBiElement: React.FC<Props> = ({ post, readingSessionId }) => {
  const { biPostScrolled, biActiveTabChanged } = useActions();
  const { isEditor, isSSR } = useEnvironment();
  const handleScroll: OnScrollHandler = useCallback(
    (event) => {
      biPostScrolled({
        post_stable_id: post?.id,
        is_demo: post?.isDemo,
        ...event,
      });
    },
    [post?.id, post?.isDemo, biPostScrolled],
  );

  const handleTabVisibilityChange: OnTabVisibilityChangeHandler = useCallback(
    (event) => {
      biActiveTabChanged({
        post_stable_id: post?.id,
        is_demo: post?.isDemo,
        ...event,
      });
    },
    [post?.id, post?.isDemo, biActiveTabChanged],
  );

  if (isSSR || isEditor) {
    return null;
  }

  return (
    <ReadingTimeListener
      getContentContainer={getPostContentContainer}
      onScroll={handleScroll}
      onTabVisibilityChange={handleTabVisibilityChange}
      readingSessionId={readingSessionId}
    />
  );
};

const getPostContentContainer = () => {
  return document.querySelector('[data-hook="post"]')?.getBoundingClientRect();
};

export default PostPageReadingTimeBiElement;
